import React, { useContext, useEffect, useState } from "react";
import { SwiperSlide, Swiper } from "swiper/react";
import "swiper/css";
import SwiperCore, { Pagination } from "swiper";
import "swiper/css/pagination";
import CohortsFlipCard from "./CohortsFlipCard";
import { PersonalityDataContext } from "../Personality/MptContexts";

// install Swiper modules
SwiperCore.use([Pagination]);

const MoneyViewPager = () => {
	const cohortsMaster: any = useContext(PersonalityDataContext);
	const [swiperRef, setSwiperRef] = useState(null);

	const moveSlideToCenter = (keyId: number) => {
		//@ts-ignore
		if (keyId > swiperRef.activeIndex) {
			//@ts-ignore
			swiperRef.slideNext();
		} else {
			//@ts-ignore
			swiperRef.slidePrev();
		}
	};

	return (
		<>
			<div className="container">
				<Swiper
					slidesPerView={1}
					//@ts-ignore
					onSwiper={setSwiperRef}
					spaceBetween={10}
					pagination={{ clickable: true }}
					centeredSlides={true}
					breakpoints={{
						"@0.00": {
							slidesPerView: 1,
							spaceBetween: 10,
						},
						"@0.75": {
							slidesPerView: 1.5,
							spaceBetween: 10,
						},
						"@1.00": {
							slidesPerView: 1.9,
							spaceBetween: 10,
						},
						"@1.50": {
							slidesPerView: 3,
							spaceBetween: 10,
						},
					}}
				>
					{cohortsMaster !== null && cohortsMaster !== undefined ? (
						cohortsMaster!.map((item: any, index: number) => {
							{
								return (
									<SwiperSlide key={index}>
										{({ isActive }) => (
											<div className="container-slider">
												<CohortsFlipCard
													localKey={index}
													isActiveCard={isActive}
													cohortData={item}
													moveSlide={moveSlideToCenter}
												/>
											</div>
										)}
									</SwiperSlide>
								);
							}
						})
					) : (
						<></>
					)}
				</Swiper>
			</div>
			<style jsx>{`
				.container {
					width: 100vw;
					height: 100%;
					display: flex;
					align-items: center;
				}
				:global(.swiper-pagination-bullet-active) {
					background-color: #000;
				}
				:global(.swiper) {
					width: 100%;
					height: 100%;
				}
				:global(.swiper-slide) {
					text-align: center;
					font-size: 18px;
					background: #fff;
					display: -webkit-box;
					display: -ms-flexbox;
					display: -webkit-flex;
					display: flex;
					-webkit-box-pack: center;
					-ms-flex-pack: center;
					-webkit-justify-content: center;
					justify-content: center;
					-webkit-box-align: center;
					-ms-flex-align: center;
					-webkit-align-items: center;
					align-items: center;
					transition: all 200ms linear;
					transform: scale(0.7);
				}
				:global(.swiper-slide-active) {
					transform: scale(1);
				}
				.container-slider {
					height: 85%;
					width: 100vw;
					margin: 2%;
				}
				@media only screen and (min-width: 699px) {
					.container-slider {
						width: 70vw;
					}
				}
			`}</style>
		</>
	);
};

export default MoneyViewPager;
